import { Pipe, PipeTransform } from '@angular/core';
import { EnvVariables } from '../../environments/environment';

/**
 * Generated class for the FormatJobImgPipe pipe.
 *
 * See https://angular.io/api/core/Pipe for more info on Angular Pipes.
 */
@Pipe({
  name: 'formatJobImg',
})
export class FormatJobImgPipe implements PipeTransform {
  constructor(public env: EnvVariables) {}
  /**
   * Takes a imgUrl from a job and creats an img src for the google map on a job
   */
  transform(value: string, ...args) {
    return (
      'https://maps.googleapis.com/maps/api/staticmap?' +
      'key=' +
      this.env.googleApiKey +
      '&size=' +
      ((args && args[0]) || '375x225') +
      '&scale=2&' +
      value
    );
  }
}



// WEBPACK FOOTER //
// ./src/pipes/format-job-img/format-job-img.ts